/*
* Copyright (C) Regione Lombardia
*/
import { Component } from '@angular/core';

@Component({
    selector: 'app-pages-cms-redazione',
    templateUrl: './redazione.component.html',
})
export class PagesCmsRedazioneComponent { }
